module.exports = __webpack_public_path__ + "72df0af65e64a9eb615a9bdcac505fd8.png";